<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)' }">
    <div class="wallboardViewSlideContentArea h-100">
        <div class="m-3" [ngStyle]="{'background-color':setBackground()}" style="height:95%" *ngIf="isLoading">
            <div class="d-flex flex-column h-100 justify-content-center align-items-center font-size-24">
                <div class="position-relative mb-5"><cv-loader [overlay]="false" size="large"></cv-loader></div>
                <div class="mt-5 pt-2" cvLocalizedText langSection="Challenges" langKey="Loading_Challenges">Just a moment, we are loading challenges data.</div>
            </div>
        </div>

        <div *ngIf="!isLoading" class="h-100">
            <!-- NO ACTIVE CHALLENGES -->
            <div class="h-100" *ngIf="activeChallenges.length == 0">
                <div class="m-3 text-white font-weight-bold" style="height:95%; font-size:5vh" [ngStyle]="{ 'background-color': setBackground() }">
                    <div class="d-flex flex-column h-100 justify-content-center align-items-center">
                        <div class="d-flex mb-1">
                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-white" style="width:14vh; height:14vh"><use href="../App_Themes/clearview-default/icons/utility/challenge-outline.svg#challenge-outline"></use></svg>
                        </div>

                        <div class="d-flex" cvLocalizedText langSection="Wallboard_Management" langKey="No_Challenges2">No Active Challenges Yet</div>
                    </div>
                </div>
            </div>
        
            <div class="h-100" *ngIf="activeChallenges.length == 1">
                <!-- SINGLE CHALLENGE WITH TWO PLAYERS -->
                <div class="align-middle h-100" *ngIf="activeChallenges?.[0].Rankings.length <= 2">
                    <div class="d-flex m-3 text-white font-weight-bold" style="height:95%">
                        <div class="w-25 mx-3">
                            <div class="h-100" [ngStyle]="{'background-color':setBackground()}">
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center mt-2">
                                        <img src="../App_Themes/Standard/Images/CoreTheme/Dashboard/ModuleImages/Challenges/Challenge.png" style="width:15vh; height:15vh" />
                                    </div>

                                    <div class="d-flex justify-content-center text-truncate" style="font-size:4.5vh">{{activeChallenges?.[0].Metrics}}</div>
                                    <div class="d-flex justify-content-center" style="font-size:3.5vh">{{getDateString(activeChallenges?.[0].EndDate_ForView)}}</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row:3; width:90%; border-bottom:1px solid #D2D6DB"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="d-flex flex-row justify-content-center">
                                        <span style="font-size:4.5vh">{{activeChallenges?.[0].Wager | numberLocalize}}
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white mb-2" style="width:5.5vh; height:5.5vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                            </svg>
                                        </span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:3.5vh" cvLocalizedText langSection="Challenges" langKey="Wager">Wager</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row: 3; width: 90%; border-bottom: 1px solid #D2D6DB;"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center">
                                        <span style="font-size: 4.5vh">{{activeChallenges?.[0].Pot | numberLocalize}}
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white mb-2" style="width:5.5vh; height:5.5vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                            </svg>
                                        </span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:3.5vh" cvLocalizedText langSection="Challenges" langKey="Pot">Pot</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row:3; width:90%; border-bottom:1px solid #D2D6DB"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center">
                                        <span style="font-size: 4.5vh">{{getMetric(activeChallenges?.[0].Rankings[0].ViewScore)}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:3.5vh" cvLocalizedText langSection="Challenges" langKey="Leading_Score">Leading Score</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row:3; width:90%; border-bottom:1px solid #D2D6DB"></div>
                                </div>

                                <div class="d-flex flex-column mb-1">
                                    <div class="d-flex justify-content-center">
                                        <span style="font-size:4.5vh">
                                            {{activeChallenges?.[0].TotalParticipants}}/{{activeChallenges?.[0].Details.InvitedCount}}

                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white mb-2" style="width:5vh; height:5vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/admin-user.svg#admin-user"></use>
                                            </svg>
                                        </span>
                                    </div>

                                    <div class="d-flex justify-content-center mb-3" style="font-size:3.5vh" cvLocalizedText langSection="Challenges" langKey="Joined_Players">Joined Players</div>
                                </div>
                            </div>
                        </div>

                        <div class="w-75 mx-3">
                            <div class="row h-100" [ngStyle]="{'background-color':setBackground()}" *ngIf="activeChallenges?.[0].TotalParticipants < 2">
                                <div class="col my-auto">
                                    <div class="mx-auto" style="border:3px solid #FFFFFF; border-radius:50%; width:40vh; height:40vh; background-repeat: no-repeat; background-size:cover"
                                         [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + activeChallenges?.[0].Rankings[0].ImageID + '&w=auto&h=auto' }"></div>

                                    <div class="d-flex justify-content-center mt-3 mb-2">
                                        <span style="font-size: 4vh">{{activeChallenges?.[0].Rankings[0].Name}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center">
                                        <span style="font-size:4vh" cvLocalizedText langSection="Challenges" langKey="Challenger">Challenger</span>
                                    </div>
                                </div>

                                <div class="w-auto border my-auto" style="height:90%"></div>

                                <div class="col my-auto" style="border-right:1px dashed white">
                                    <div class="mx-auto" style="border:3px solid #FFFFFF; border-radius:50%; width:40vh; height:40vh; background-repeat:no-repeat; background-size:cover"
                                         [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + activeChallenges?.[0].NotRankings[0].ImageID + '&w=auto&h=auto' }">
                                    </div>

                                    <div class="d-flex justify-content-center mt-3 mb-2">
                                        <span style="font-size:4vh">{{activeChallenges?.[0].NotRankings[0].Name}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center">
                                        <span style="font-size:4vh" cvLocalizedText langSection="Challenges" langKey="Pending_Invitation">Pending Invitation</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row h-100" [ngStyle]="{'background-color':setBackground()}" *ngIf="activeChallenges?.[0].TotalParticipants == 2">
                                <div class="col my-auto">
                                    <div class="mx-auto" style="border:3px solid #FFFFFF; border-radius:50%; width:40vh; height:40vh; background-repeat:no-repeat; background-size:cover"
                                         [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + activeChallenges?.[0].Rankings[0].ImageID + '&w=auto&h=auto' }">
                                    </div>

                                    <div class="d-flex justify-content-center mt-3 mb-2">
                                        <span style="font-size:4vh">{{activeChallenges?.[0].Rankings[0].Name}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center">
                                        <span style="font-size:4vh">{{getMetric(activeChallenges?.[0].Rankings[0].ViewScore)}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:4vh" cvLocalizedText langSection="Challenges" langKey="Leading_Score">Leading Score</div>
                                </div>

                                <div class="w-auto border my-auto" style="height:90%"></div>

                                <div class="col my-auto" style="border-right: 1px dashed white;">
                                    <div class="mx-auto" style="border:3px solid #FFFFFF; border-radius:50%; width:40vh; height:40vh; background-repeat:no-repeat; background-size:cover"
                                         [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + activeChallenges?.[0].Rankings[1].ImageID + '&w=auto&h=auto' }">
                                    </div>

                                    <div class="d-flex justify-content-center mt-3 mb-2">
                                        <span style="font-size:4vh">{{activeChallenges?.[0].Rankings[1].Name}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center">
                                        <span style="font-size:4vh">{{getMetric(activeChallenges?.[0].Rankings[1].ViewScore)}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:4vh" cvLocalizedText langSection="Scores" langKey="Score_Column">Score</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SINGLE CHALLENGE WITH MULTIPLE PLAYERS -->
                <div class="align-middle h-100" *ngIf="activeChallenges?.[0].Rankings.length > 2">
                    <div class="row m-3 text-white" style="height:90%">
                        <div class="w-25">
                            <div class="m-3 h-100" [ngStyle]="{ 'background-color': setBackground() }">
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center mt-3">
                                        <img src="../App_Themes/Standard/Images/CoreTheme/Dashboard/ModuleImages/Challenges/Challenge.png" style="width:15vh; height:15vh"/>
                                    </div>

                                    <div class="d-flex justify-content-center font-weight-bold text-truncate" style="font-size:5vh">{{activeChallenges?.[0].Metrics}}</div>
                                    <div class="d-flex justify-content-center" style="font-size:4vh">{{getDateString(activeChallenges?.[0].EndDate_ForView)}}</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row:3; width:90%; border-bottom:1px solid #D2D6DB"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center font-weight-bold">
                                        <span style="font-size:5vh">
                                            {{activeChallenges?.[0].Wager | numberLocalize}}

                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white mb-2" style="width:6vh; height:6vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                            </svg>
                                        </span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:4vh" cvLocalizedText langSection="Challenges" langKey="Wager">Wager</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row:3; width:90%; border-bottom:1px solid #D2D6DB"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center font-weight-bold">
                                        <span style="font-size:5vh">
                                            {{activeChallenges?.[0].Pot | numberLocalize}}

                                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white mb-2" style="width:6vh; height:6vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                            </svg>
                                        </span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:4vh" cvLocalizedText langSection="Challenges" langKey="Pot">Pot</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row:3; width:90%; border-bottom:1px solid #D2D6DB"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center font-weight-bold">
                                        <span style="font-size: 5vh">{{getMetric(activeChallenges?.[0].Rankings[0].ViewScore)}}</span>
                                    </div>

                                    <div class="d-flex justify-content-center" style="font-size:4vh" cvLocalizedText langSection="Challenges" langKey="Leading_Score">Leading Score</div>
                                    <div class="pt-2 mb-2 mx-auto" style="grid-row:3; width:90%; border-bottom:1px solid #D2D6DB"></div>
                                </div>

                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-center font-weight-bold">
                                        <span style="font-size:5vh">{{activeChallenges?.[0].TotalParticipants}}/{{activeChallenges?.[0].Details.InvitedCount}}
                                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-white mb-1" style="width:5.5vh; height:5.5vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/admin-user.svg#admin-user"></use>
                                            </svg>
                                        </span>
                                    </div>

                                    <div class="d-flex justify-content-center mb-3" style="font-size:4vh" cvLocalizedText langSection="Challenges" langKey="Joined_Players">Joined Players</div>
                                </div>
                            </div>
                        </div>

                        <div class="w-75">
                            <div class="m-3 h-100" [ngStyle]="{ 'background-color': setBackground() }">
                                <div class="px-4 bg-transparent font-weight-bold">
                                    <div class="row pt-3 mb-4" style="font-size:3vh">
                                        <div class="w-50 pl-5">
                                            <span class="pl-5" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Agents">Agents</span>
                                        </div>

                                        <div class="w-50 text-center my-auto" cvLocalizedText langSection="Scores" langKey="Score_Column">Scores</div>
                                    </div>

                                    <div class="row" *ngFor="let player of activeChallenges?.[0].Rankings | startOn:currentPage*maxRows:true | limitTo:maxRows; let $last = last">
                                        <div class="w-50 h-100 d-flex flex-row align-items-end">
                                            <span class="d-flex align-items-center">
                                                <div class="mx-4" style="font-size:5vh">{{player.Place < 0 ? "  -  " : (activeChallenges?.[0].Rankings.indexOf(player) + 1)}}</div>
                                                <div style="border:3px solid #FFFFFF; border-radius:50%; width:7vh; height:7vh; background-repeat:no-repeat; background-size:cover"
                                                     [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + player.ImageID + '&w=auto&h=auto)' }"></div>
                                                <div class="ml-4" style="font-size:4vh">{{player.Name}}</div>
                                            </span>
                                        </div>

                                        <div class="w-50 text-center my-auto" style="font-size:4vh" *ngIf="player.Place >= 0">{{getMetric(player.ViewScore)}}</div>
                                        <div class="w-50 text-center my-auto" style="font-size:4vh" *ngIf="player.Place < 0"
                                             cvLocalizedText langSection="Challenges" langKey="Pending_Invitation">Pending Invitation</div>
                                        <div class="pt-2 mb-1 mx-auto" style="grid-row:3; width:95%; border-bottom:1px solid #D2D6DB" *ngIf="!$last"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="font-size-48 text-center position-absolute" style="bottom:50px; right:50px; width:120px; height:80px; background-color:rgba(0, 0, 0, 54%)" *ngIf="totalPages > 0">
                        {{(currentPage + 1) + "/" + totalPages}}
                    </div>
                </div>
            </div>

            <!-- BETWEEN TWO AND FOUR CHALLENGES -->
            <div class="d-flex align-items-center flex-wrap justify-content-center h-100 m-0" *ngIf="activeChallenges.length > 1 && activeChallenges.length < 5">
                <div class="d-inline-block mx-3 my-2 text-white" style="height:45vh; width:45vw" [ngStyle]="{ 'background-color':setBackground() }" *ngFor="let challenge of activeChallenges">
                    <div class="row h-100">
                        <div class="col h-100 w-50">
                            <div class="d-flex flex-row h-25 pt-3 ml-3">
                                <div class="d-flex flex-column">
                                    <div class="h-100">
                                        <img src="../App_Themes/Standard/Images/CoreTheme/Dashboard/ModuleImages/Challenges/Challenge.png" style="width:9vh; height:9vh"/>
                                    </div>
                                </div>

                                <div class="col ml-2 px-0">
                                    <div class="h-50 w-75 font-weight-bold text-truncate" style="font-size:3vh">{{challenge.Metrics}}</div>
                                    <div class="h-50" style="font-size:2.5vh">{{getDateString(challenge.EndDate_ForView)}}</div>
                                </div>
                            </div>

                            <div class="d-flex flex-column h-75 mt-3 ml-4">
                                <div class="d-flex flex-row text-left align-items-center my-3">
                                    <div class="align-middle" style="width:60%; font-size:2.5vh" cvLocalizedText langSection="Challenges" langKey="Wager">Wager</div>

                                    <div class="font-weight-bold" style="font-size:3vh">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-white mb-1" style="width: 4vh; height: 4vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                            </svg>

                                            {{challenge.Wager | numberLocalize}}
                                        </span>
                                    </div>
                                </div>

                                <div class="d-flex flex-row text-left align-items-center my-3">
                                    <div class="align-middle" style="width:60%; font-size:2.5vh" cvLocalizedText langSection="Challenges" langKey="Pot">Pot</div>

                                    <div class="font-weight-bold" style="font-size:3vh">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-white mb-1" style="width: 4vh; height: 4vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                            </svg>

                                            {{challenge.Pot | numberLocalize}}
                                        </span>
                                    </div>
                                </div>

                                <div class="d-flex flex-row text-left align-items-center my-3">
                                    <div class="align-middle" style="width:60%; font-size:2.5vh" cvLocalizedText langSection="Challenges" langKey="Joined_Players">Joined Players</div>

                                    <div class="font-weight-bold" style="font-size:3vh">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-white mb-1" style="width: 3.5vh; height: 3.5vh">
                                                <use href="../App_Themes/clearview-default/icons/utility/admin-user.svg#admin-user"></use>
                                            </svg>

                                            {{challenge.TotalParticipants}}/{{challenge.Details.InvitedCount}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-auto border my-auto" style="height:80%"></div>

                        <div class="col h-100 w-50">
                            <div class="mx-auto mt-4" style="border-radius:50%; width:19vh; height:19vh; background-repeat:no-repeat; background-size:cover"
                                 [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + challenge.Rankings[0].ImageID + '&w=auto&h=auto)' }">
                            </div>

                            <div class="d-flex flex-column my-2">
                                <div class="d-flex justify-content-center" style="font-size:2.5vh" cvLocalizedText langSection="Games" langKey="First_Place">1st Place</div>
                                <div class="d-flex justify-content-center font-weight-bold text-truncate" style="font-size:3vh">{{challenge.Rankings[0].Name}}</div>
                            </div>

                            <div class="d-flex flex-column my-2">
                                <div class="d-flex justify-content-center" style="font-size:2.5vh">{{challenge.Metrics}}</div>
                                <div class="d-flex justify-content-center font-weight-bold" style="font-size:3vh">{{getMetric(challenge.Rankings[0].ViewScore)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FIVE OR MORE CHALLENGES -->
            <div class="h-100" *ngIf="activeChallenges.length > 4">
                <div class="m-3 text-white" style="height:95%; font-size:3vh" [ngStyle]="{ 'background-color':setBackground() }">
                    <div class="row p-2"></div>

                    <div class="row p-3 text-center">
                        <div class="col-2 p-0" cvLocalizedText langSection="Common" langKey="Metric">Metric</div>
                        <div class="col-2 p-0" cvLocalizedText langSection="Challenges" langKey="Leader">Leader</div>
                        <div class="col-2 p-0 pl-5" cvLocalizedText langSection="Challenges" langKey="Leading_Score">Leading Score</div>
                        <div class="col-2 p-0" cvLocalizedText langSection="Challenges" langKey="Wager">Wager</div>
                        <div class="col-2 p-0" cvLocalizedText langSection="Challenges" langKey="Pot">Pot</div>
                        <div class="col-2 p-0" cvLocalizedText langSection="Common" langKey="End_Date">End Date</div>
                    </div>

                    <div class="row px-3 mt-2" style="font-size: 3vh" *ngFor="let challenge of activeChallenges | startOn:currentPage*maxRows:true | limitTo:maxRows; let $last = last">
                        <div class="col p-0 text-truncate">
                            <img class="mx-2" style="width:6vh; height:6vh" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/ModuleImages/Challenges/Challenge.png" />
                            {{challenge.Metrics}}
                        </div>

                        <div class="text-center py-1 col-2 text-truncate">{{challenge.Rankings[0].Name}}</div>
                        <div class="text-right py-1 pr-5 col-2">{{challenge.Rankings[0].ViewScore}}</div>

                        <div class="text-center py-1 col-2">{{challenge.Wager | numberLocalize}} 
                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white" style="width:5vh; height:5vh"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                        </div>

                        <div class="text-center py-1 col-2">{{challenge.Pot | numberLocalize}} 
                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white" style="width:5vh; height:5vh"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                        </div>

                        <div class="text-center py-1 col-2">{{getDateString(challenge.EndDate_ForView)}}</div>
                        <div *ngIf="!$last" class="mt-2 mt-1 mx-auto" style="grid-row:3; width:98%; border-bottom:1px solid #D2D6DB"></div>
                    </div>
                </div>

                <div class="font-size-48 text-center position-absolute" style="bottom:50px; right:50px; width:120px; height:80px; background-color:rgba(0, 0, 0, 54%)" *ngIf="totalPages > 0">
                    {{(currentPage + 1) + "/" + totalPages}}
                </div>
            </div>
        </div>
    </div>
</div>
